// extracted by mini-css-extract-plugin
export var productImage = "_zn-0";